import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import WelcomeIntro from "../../components/WelcomeIntro";
import { getisCompletedAssessment360 } from "../../axios/axiosFunctions";
import WelcomeIntro360 from "../../components/WelcomeIntro360";

const REVIEWER_INTRO_TEXT = {
    "lim_360_assessment": (name) =>
        `Welcome to the Leaders in Motion<sup>&reg;</sup> 360-assessment. This 30-question survey will ask you to evaluate <strong>${name}'s</strong> current confidence and effectiveness in the competencies that have been identified as critical for great people managers. Please answer the questions as honestly as possible — your individual responses will remain confidential and will be combined with feedback from other reviewers to provide <strong>${name}</strong> with a well-rounded perspective on their management strengths and development areas. The survey should require less than 15 minutes. Thank you for taking the time to support <strong>${name}'s</strong> growth on their Leaders in Motion<sup>&reg;</sup> journey.`,
    "mim_360_assessment": (name) =>
        `Welcome to the Managers in Motion<sup>&reg;</sup> 360-assessment. This 30-question survey will ask you to evaluate <strong>${name}'s</strong> current confidence and effectiveness in the competencies that have been identified as critical for great people managers. Please answer the questions as honestly as possible — your individual responses will remain confidential and will be combined with feedback from other reviewers to provide <strong>${name}</strong> with a well-rounded perspective on their management strengths and development areas. The survey should require less than 15 minutes. Thank you for taking the time to support <strong>${name}'s</strong> growth on their Managers in Motion<sup>&reg;</sup> journey.`,
    "simple_360_feedback": (name) =>
        `Welcome to the Simple 360 Feedback survey. You have been invited to share feedback about <strong>${name}</strong> as a leader. This short survey has 4 open-ended questions and should take about 5 minutes. Your responses are anonymous — <strong>${name}</strong> will not see who provided which feedback. Please answer as honestly and specifically as possible — your responses will be compiled into a summary feedback report to support <strong>${name}'s</strong> growth as a leader. Thank you for taking the time to contribute.`,
};

const Welcome360 = ({loading,introText,mainImage,name,blocks,id,changeTab,setCurrentBlock,assessmentId,revieweeName,assessmentSlug}) => {

    const navigate = useNavigate();
    const {userEvalId,userId} = useParams();
    const [lastCompleted, setLastCompleted] = useState({slug:"",pos:0});

    useEffect(() => {
        const callIsCompleteAssessment = async()=>{
            const isComplete = await getisCompletedAssessment360(assessmentId,userId,userEvalId);
            if(isComplete.valid){
                changeTab(2);
                return;
            }
            setLastCompleted(isComplete.slug);
        }
        callIsCompleteAssessment()
    }, [assessmentId])

    // Determine if current user is the reviewee (self-assessment) or a reviewer
    const isReviewee = userId === userEvalId;

    // Build personalized intro text for reviewers; reviewees see the assessment's own introText
    const getIntroText = () => {
        if (!isReviewee && revieweeName && assessmentSlug && REVIEWER_INTRO_TEXT[assessmentSlug]) {
            return REVIEWER_INTRO_TEXT[assessmentSlug](revieweeName);
        }
        return introText;
    };

    return (
        <Box display="flex" flexDirection="column">
            {
                loading && <Box sx={{padding:"48px"}}><CircularProgress/></Box>
            }
            {
                !loading && <>
                    <Box sx={{backgroundColor:"#e8f4f8",padding:"48px 48px 40px",borderRadius:"0 0 0 0"}}>
                        <Typography variant='h4' color='primary' fontWeight={600}>WELCOME</Typography>
                        <WelcomeIntro360 introText={getIntroText()} mainImage={mainImage} slug={lastCompleted} blocks={blocks} changeTab={changeTab} setCurrentBlock={setCurrentBlock}/>
                    </Box>
                </>
            }
        </Box>
    )
}

export default Welcome360
